import { render, staticRenderFns } from "./LogoutMsal.vue?vue&type=template&id=a83eb3fe&scoped=true&"
import script from "./LogoutMsal.vue?vue&type=script&lang=js&"
export * from "./LogoutMsal.vue?vue&type=script&lang=js&"
import style0 from "./LogoutMsal.vue?vue&type=style&index=0&id=a83eb3fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83eb3fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VBtn,VDivider,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VMenu})
